// Copyright (c) 2016 Deere & Company

import './part-returns.scss';
import React, {PropTypes} from 'react';

const PartReturns = props =>
    <section>
        {props.children}
    </section>;

PartReturns.displayName = 'PartReturns';
PartReturns.propTypes = {
    children: PropTypes.node
};

export default PartReturns;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-returns.js